<template>
  <div class="s-articles s-articles--overview">
    <div class="s-articles__title">{{ dictionary.articlesTitle }}</div>
    <div class="s-articles__filters">
      <ArticlesFilters @change-filters="onChangeFilters" />
    </div>
    <div v-if="records" class="s-articles__main">
      <div
        v-for="(item, index) in records"
        :key="index"
        class="s-articles__item">
        <ArticleSingle :item="item" />
      </div>
    </div>
    <div v-if="hasMore" class="s-articles__view-more">
      <a
        href="javascript:void(0)"
        class="btn btn--block btn-icon-outline-blue"
        @click="fetchData">
        <span>{{ dictionary.articleShowMoreLabel }}</span>
      </a>
    </div>
  </div>
</template>
<script>
import * as lib from '../../lib/lib'
import axios from 'axios'
import ArticleSingle from './../components/ArticleSingle.vue'
import ArticlesFilters from './../components/ArticlesFilters.vue'

export default {
  components: { ArticleSingle, ArticlesFilters },
  data() {
    return {
      records: [],
      slickActive: null,

      selectedFilter: '',
      selectedYear: '',

      pageNumber: 1,
      hasMore: true,

      // time: 0,
      // timerRunning: false,
    }
  },
  computed: {
    speedInSec() {
      return this.slickOptions.autoplaySpeed / 1000
    },
  },
  mounted() {
    const { showMoreLink } = lib.getData('articlesOverviewData')
    this.showMoreLink = showMoreLink

    this.$nextTick(() => {
      // this.startTimer()
      this.fetchData()
    })
  },
  methods: {
    onChangeFilters(filter, year) {
      // console.log(filter, year)

      this.selectedFilter = filter
      this.selectedYear = year

      lib.appendUrlParams(
        ['filter', 'year'],
        [this.selectedFilter, this.selectedYear]
      )

      this.fetchData()
    },

    fetchData() {
      this.isLoading = true

      const postData = {
        reCaptchaPublicKey: this.configuration.reCaptchaPublicKey,
        selectedFilter: this.selectedFilter,
        selectedYear: this.selectedYear,
        pageNumber: this.pageNumber,
      }

      axios
        .post(this.configuration.dataHandler, postData)
        .then((response) => {
          const { hasError, errorMessages, data, hasMore } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          if (hasMore !== null && hasMore !== undefined) {
            this.hasMore = hasMore
          }

          const { records } = data
          this.records = [...this.records, ...records]

          this.$nextTick(() => {
            this.pageNumber += 1
            this.handleSuccess()
          })
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
    // reset() {
    //   this.stopTimer()
    // },
    // pause() {
    //   this.timerRunning = false
    // },
    // play() {
    //   this.timerRunning = true
    // },
    // doThis() {
    //   // this.stopTimer()
    //   this.startTimer()
    // },
    // startTimer() {
    //   if (!this.timerRunning) {
    //     this.intervalId = setInterval(() => {
    //       if (this.time < this.slickOptions.autoplaySpeed - 100) {
    //         this.time += 100
    //         this.updateVisual(this.time)
    //       } else {
    //         this.stopTimer()
    //       }
    //     }, 100)
    //     this.timerRunning = true
    //   }
    //   console.log('Start timer')
    // },
    // stopTimer() {
    //   clearInterval(this.intervalId)
    //   this.time = 0
    //   this.updateVisual(this.time)
    //   this.timerRunning = false
    // },
    // updateVisual(time) {
    //   const progress = Math.floor(
    //     (time / this.slickOptions.autoplaySpeed) * 100
    //   )
    //   // const styleElem = document.head.appendChild(
    //   //   document.createElement('style')
    //   // )
    //   // styleElem.innerHTML = `.s-articles__slick .slick-dots .slick-active::after {width: ${progress}%;}`
    // },
  },
}
</script>
<style lang="scss">
.s-articles__slick {
  .slick-dots {
    .slick-active:after {
      transition: all 0.3s;

      content: '';
      position: absolute;
      top: 0;
      left: 0;

      height: 8px;
      width: 0%;
      border-radius: 3px;
      background-color: #ff9840;

      animation: progress v-binds(speedInSec) linear forwards;
    }
  }
}

@keyframes progress {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>
